<template>
  <v-card v-if="value">
    <v-card-title class="primary--text title">
      ประวัติการอัปโหลดใบเสร็จ <v-spacer />
      <v-btn small flat fab @click="$emit('onClose')"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-card-text>
      <Pagination
        v-model="page"
        :limit="limit"
        :total="total"
        :key="'top_pagination_' + timestamp"
        @onChange="onChange($event)"
      ></Pagination>

      <v-data-table
        :headers="headers"
        :pagination.sync="pagination"
        :items="data"
        class="elevation-1"
        hide-actions
        :loading="loading"
      >
        <template v-slot:items="props">
          <tr>
            <td>{{ props.index + 1 }}</td>
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.receipt_no }}</td>
            <td>{{ props.item.total }}</td>
            <td>
              {{ props.item.timestamp | dateFormat('DD/MM/YYYY เวลา HH:mm น.') }}
            </td>
          </tr>
        </template>
      </v-data-table>

      <Pagination
        v-model="page"
        :limit="limit"
        :total="total"
        :key="'bottom_pagination_' + timestamp"
        @onChange="onChange($event)"
      ></Pagination>
    </v-card-text>
  </v-card>
</template>

<script>
import Pagination from '@/components/elements/Pagination.vue'
import api from '@/api'
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  props: ['value'],
  data() {
    return {
      total: 0,
      pagination: {
        rowsPerPage: -1
      },
      headers: [
        {
          sortable: false,
          text: 'ลำดับ'
        },
        {
          value: 'name',
          text: 'ชื่อสมาชิก'
        },
        {
          value: 'receipt_no',
          text: 'เลขที่ใบเสร็จ'
        },
        {
          value: 'total',
          text: 'ยอดซื้อต่อใบเสร็จ'
        },

        {
          value: 'timestamp',
          text: 'วันที่อัปโหลดใบเสร็จ'
        }
      ],
      data: [],
      limit: 25,
      page: 1,
      total: 0,
      loading: true,
      timestamp: moment().format('x')
    }
  },
  components: {
    Pagination
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    selectedCampaign() {
      return this.$store.state.selectToaCampaign
    }
  },
  async mounted() {},
  methods: {
    async getStoreHistory(limit, offset) {
      if (!this.value) return false
      const { sortBy, descending } = this.pagination
      let response = await api.getStoreHistory({
        pageid: this.selectedBot.pageid,
        campaignid: this.selectedCampaign ? this.selectedCampaign.id : null,
        limit: limit,
        offset: offset,
        sortBy: sortBy,
        descending: descending,
        store_id: this.value ? this.value.store_id : null
      })
      return {
        total: response ? response.total : 0,
        data: response ? response.data : []
      }
    },

    async onChange(val) {
      this.loading = true
      let { data, total } = await this.getStoreHistory(val.limit, val.offset)
      this.total = total
      this.data = data
      this.loading = false
    }
  },
  watch: {
    async pagination() {
      this.loading = true
      let { data, total } = await this.getStoreHistory(this.limit, 0)
      this.total = total
      this.data = data
      this.page = 1
      this.timestamp = moment().format('x')
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toaecoupon/StoreHistory.vue